import get from 'lodash/get';
import { string } from 'prop-types';

import { rem } from '@blueprint/ui';

import { Box, Icon } from 'components/blueprint';
import { colors } from 'themes';

const answerBackgroundColor = get(colors, 'formElements.12');

export const Avatar = ({ iconName }) => (
  <Box
    display="flex"
    flexShrink={0}
    justifyContent="center"
    alignItems="center"
    alignSelf="end"
    width={rem(32)}
    height={rem(32)}
    borderRadius="50%"
    backgroundColor={answerBackgroundColor}
    marginBottom={rem(20)}
  >
    <Icon name={iconName} size={rem(14)} aria-hidden />
  </Box>
);

Avatar.propTypes = {
  /**
   * Icon Name
   */
  iconName: string,
};
